import { parse } from "node-html-parser";

export function stripHtml(html) {
  if (!html) {
    return false;
  } else {
    let doc = parse(html);
    return doc.textContent || doc.innerText || "";
  }
}
